import React, { useEffect, useRef, useState } from 'react';
import styles from './Viewer.module.scss';
import WebGL from 'three/addons/capabilities/WebGL.js';
import { ReactPhotoSphereViewer, GalleryPlugin } from 'react-photo-sphere-viewer';
import { addCustomPathToLink } from '../../functions';

const Viewer = ({ api, type }) => {
  const photoSphereRef = useRef();
  const [nodes, setNodes] = useState();

  const plugins = [
    [
      GalleryPlugin,
      {
        thumbnailSize: { width: 100, height: 100 },
        visibleOnLoad: true,
      },
    ],
  ];

  const navbarFull = [
    'zoom',
    'gallery',
    'move',
    {
      id: 'galerryprev',
      content:
        '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20 13L13 20L20 27" stroke="white" stroke-width="2" stroke-linecap="round"/> <path d="M27 13L20 20L27 27" stroke="white" stroke-width="2" stroke-linecap="round"/> </svg>',
      title: 'Poprzedni',
      className: 'prev-button',
      onClick: (viewer) => {
        let items = document.getElementsByClassName('psv-gallery-item');
        let prev = 0;
        for (let i = 0; i < items.length; i++) {
          if (items[i].classList.contains('psv-gallery-item--active')) {
            prev = i - 1;
          }
        }
        if (prev < 0) prev = items.length - 1;
        items[prev].click();
        //alert('prev '+prev);
      },
    },
    {
      id: 'galerrynext',
      content:
        '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20 27L27 20L20 13" stroke="white" stroke-width="2" stroke-linecap="round"/> <path d="M13 27L20 20L13 13" stroke="white" stroke-width="2" stroke-linecap="round"/> </svg>',
      title: 'Następny',
      className: 'next-button',
      onClick: (viewer) => {
        let items = document.getElementsByClassName('psv-gallery-item');
        let next = 0;
        for (let i = 0; i < items.length; i++) {
          if (items[i].classList.contains('psv-gallery-item--active')) {
            next = i + 1;
          }
        }

        if (next > items.length - 1) next = 0;
        items[next].click();
      },
    },
    'fullscreen',
  ];

  const navbarDefault = ['zoom', 'move', 'fullscreen'];

  useEffect((_) => {
    if (WebGL.isWebGLAvailable()) {
      if (!!photoSphereRef?.current) {
        photoSphereRef.current.setOption({
          maxFov: 70,
          minFov: 10,
          fisheye: 0.4,
          touchmoveTwoFingers: true,
          mousewheelCtrlKey: true,
          loadingImg: addCustomPathToLink('loader.gif', true),
          defaultYaw: '130deg',
        });
      }
      if (!!api.attributes?.nodes) {
        api.attributes.nodes.forEach((node) => {
          node.panorama = addCustomPathToLink(node.panorama, true);
          node.thumbnail = addCustomPathToLink(node.panorama, true);
          !!node?.links &&
            node.links.forEach((link, index) => {
              const nodeId = link.panoramaid;
              node.links[index] = { nodeId: nodeId, position: { textureX: parseInt(link.osx), textureY: parseInt(link.osy) } };
            });
        });
        setNodes(api.attributes.nodes);
      }
    }
  }, []);

  const handleReady = (instance) => {
    if (!!api.attributes?.nodes) {
      const gallery = instance.getPlugin(GalleryPlugin);
      gallery.setItems(nodes);
    }
  };

  const handleClick = () => {
    photoSphereRef.current.animate({
      yaw: 0,
      pitch: 0.5,
      speed: '10rpm',
    });
  };

  return (
    <section
      id={api?.id}
      className={`wrapper ${styles.sectionViewer} ${!!type && (type == 'halfWidth' || type.includes('halfWidth')) ? styles.halfWidth : ''}`}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      {!!api.attributes?.title && (
        <div
          className={styles.textContent}
          data-aos="fade-up"
          // data-aos-delay="300"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          <h2 className={styles.title}>{api.attributes.title}</h2>
        </div>
      )}
      {!WebGL.isWebGLAvailable() ? (
        <figure className={styles.noImageOverlay}>
          <img
            className={styles.imageNoScript}
            src={addCustomPathToLink('a0436547-2e4c-4401-ab86-26eb3d135ecb/zaslepka-foto-blenda.jpg', true)}
            alt="Nieobsługiwana technologia WebGL"
          />
          <figcaption className={styles.overlayTextWrapper}>
            <p className={`${styles.overlayHeading} ${styles.overlayUpperHeading}`}>
              Twoja przeglądarka nie obsługuje technologi 3d, wymaganej do poprawnego wyświetlania katalogu Leroy Merlin.
            </p>
            <p className={`${styles.overlayHeading} ${styles.overlayLowerHeading}`}>
              Zalecamy użycie najnowszej wersji przeglądarki Google Chrome lub Safari
            </p>
          </figcaption>
        </figure>
      ) : !!nodes ? (
        <ReactPhotoSphereViewer
          ref={photoSphereRef}
          src={nodes[0].panorama}
          height={'100vh'}
          width={'100%'}
          onClick={handleClick}
          plugins={plugins}
          navbar={navbarFull}
          onReady={handleReady}
        ></ReactPhotoSphereViewer>
      ) : (
        !!api?.attributes?.image?.src && (
          <ReactPhotoSphereViewer
            ref={photoSphereRef}
            src={addCustomPathToLink(api.attributes.image.src, true)}
            height={'100vh'}
            width={'100%'}
            onClick={handleClick}
            navbar={navbarDefault}
            onReady={handleReady}
          ></ReactPhotoSphereViewer>
        )
      )}
    </section>
  );
};

export default Viewer;
